import React, { ChangeEvent, ReactNode } from 'react';

const Checkbox = ({ options }: { options: CheckboxOptions }) => {
  const {
    label,
    id,
    defaultChecked = false,
    checked = false,
    disabled = false,
    required = false,
    onChange,
    name,
    value,
    inputClasses = '',
    wrapperClasses = '',
    labelClasses = '',
    testId = '',
  } = options;

  return (
    <div className={`yoga-ui-checkbox ${wrapperClasses}`} data-testid={testId}>
      <input
        id={id}
        type="checkbox"
        defaultChecked={defaultChecked}
        onChange={(event) => {
          onChange && onChange(event);
        }}
        checked={checked}
        disabled={disabled}
        required={required}
        value={value}
        name={name}
        className={inputClasses}
      />
      {typeof label === 'string' ? (
        <label htmlFor={id} className={labelClasses}>
          {label}
        </label>
      ) : (
        label
      )}
    </div>
  );
};

export default Checkbox;

interface CheckboxOptions {
  id: string;
  label?: string | ReactNode;
  labelNode?: ReactNode;
  defaultChecked?: boolean;
  checked?: boolean;
  disabled?: boolean;
  required?: boolean;
  value?: string;
  name?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  inputClasses?: string;
  wrapperClasses?: string;
  labelClasses?: string;
  testId?: string;
}
